const initialState = {
    storesInList: [],
    itemsInList: [],
};

export default initialState;

